import { useQuery, useQueryClient } from "react-query";

export const COMMON_USER_QUERY_KEY = "commonUserQueryKey";

export const useUserQuery = () => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: [COMMON_USER_QUERY_KEY],
    retry: false,
    queryFn: () => {
      return queryClient.getQueryData(COMMON_USER_QUERY_KEY);
    },
    initialData: undefined,
  });
};
